export default __webpack_public_path__ + "static/media/planning.8ac6b82d.jpg";